module.exports = __webpack_public_path__ + "static/media/van_red.04696d77.svg";